import { FunctionComponent } from 'react';
import { StyledProductIcon } from './ProductIcon.styles';
import { v4 as uuidv4 } from 'uuid';
import { TableFriendlyTooltip } from 'components/tables/TableFriendlyTooltip';
import { getProductConfig } from '../../../../domain/product/productMap';

interface ProductIconProps {
	productId: string;
	size?: string;
	fontSize?: string;
	withTooltip?: boolean;
}

export const ProductIcon: FunctionComponent<ProductIconProps> = ({
	productId,
	size = 'xxl',
	fontSize = 'md',
	withTooltip = true,
}) => {
	const productConfig = getProductConfig(productId);
	const tooltipId = uuidv4().replaceAll('-', '');

	if (!productConfig) return null;

	return withTooltip ? (
		<>
			<TableFriendlyTooltip id={tooltipId} maxWidth={160} />
			<StyledProductIcon
				$color={productConfig.icon.color}
				$textColor={productConfig.icon.textColor}
				$size={size}
				$fontSize={fontSize}
				data-tooltip-content={productConfig.name}
				data-tooltip-id={tooltipId}
			>
				{productConfig.icon.initials}
			</StyledProductIcon>
		</>
	) : (
		<StyledProductIcon
			$color={productConfig.icon.color}
			$textColor={productConfig.icon.textColor}
			$size={size}
			$fontSize={fontSize}
		>
			{productConfig.icon.initials}
		</StyledProductIcon>
	);
};
